// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav-tabs-wrapper {
    display: block;
    overflow: hidden;
    position: relative;
    z-index: 1;
    margin: 40px 0;
}
.mb-5, .my-5 {
    margin-bottom: 3rem !important;
}
.filters-box {
    border-radius: 0.43rem;
    background-color: #f8f9fa;
}
.p-4 {
    padding: 1.5rem !important;
}
.table-responsive.table-borders {
    border: 0.07rem solid #EBECF0;
}
.table-responsive.table-radius {
    border-radius: 6px;
}
.table-responsive {
    width: 100%;
}
.section-services
{
    /* padding: 20px; */
    padding-left: 20px;
    padding-right: 20px;
}
a{-webkit-text-decoration: "none";text-decoration: "none"}

.swal2-popup.custom-popup {
    margin-top: 160px !important; /* Đẩy popup xuống 100px */
}
.swal2-input-small {
    height: 30px !important; 
    font-size: 14px !important;
    padding: 5px !important; 
    text-align: center; 
    
}
.swal2-validation-message::before {
    display: none !important; /* Ẩn icon lỗi mặc định */
}
/* 
.swal2-popup .swal2-loading {
    position: absolute;
    top: 80%;
    left: 50%;
    transform: translate(-50%, -50%);
} */
.form-group {
    margin-bottom: 15px;
}

.form-control {
    font-size: 14px;
    padding: 5px;
    width: 100%;
    min-width: 120px;
}

select.form-control {
    appearance: none; /* Remove default dropdown arrow */
    padding-right: 30px; /* Space for custom dropdown arrow */
}

/* Responsive Grid */
.row.align-items-end {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
}




/* Date Inputs */
input[data-type="date"] {
    font-size: 14px;
    padding: 8px;
}

/* Button Styling */
.btn-primary {
    font-size: 13px;
    padding: 8px 16px;
}

/* Horizontal Line between inputs */
.line-f {
    margin: 0 10px;
}

input[type="text"], select {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

button.disabled-button {
    opacity: 0.5 !important;
    cursor: not-allowed !important;
    pointer-events: none; 
}

.header-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-bottom: 20px;
    position: relative;
}

.header-line {
    width: 20%;
    height: 2px;
    background-color: rgb(197, 203, 211);
    
}

.header-title {
    background: rgb(24, 98, 200);
    color: white;
    font-weight: bold;
    padding: 10px 40px;
    text-transform: uppercase;
    font-size: 16px;
    letter-spacing: 1px;
    clip-path: polygon(10% 0%, 90% 0%, 100% 50%, 90% 100%, 10% 100%, 0% 50%);
    white-space: nowrap;
    margin: 0 15px; 
}

/* Tùy chỉnh nút Confirm */
.custom-confirm-button {
    background: linear-gradient(to right, #007bff, #0056b3) !important;
    border: none !important;
    padding: 8px 20px !important;
    font-size: 16px !important;
    position: relative;
}

/* Khi bấm Confirm, spinner xuất hiện và dịch sang trái */
.swal2-loading .loading-spinner {
    display: inline-block;
    width: 18px;
    height: 18px;
    border: 3px solid white;
    border-radius: 50%;
    border-top-color: transparent;
    animation: spin 0.8s linear infinite;
    transform: translateX(-10px); /* Dịch chuyển sang trái */
}

/* Hiệu ứng xoay */
@keyframes spin {
    0% { transform: rotate(0deg) translateX(-10px); }
    100% { transform: rotate(360deg) translateX(-10px); }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Orders/Order.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,cAAc;AAClB;AACA;IACI,8BAA8B;AAClC;AACA;IACI,sBAAsB;IACtB,yBAAyB;AAC7B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,6BAA6B;AACjC;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;AACf;AACA;;IAEI,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;AACA,EAAE,+BAAsB,CAAtB,uBAAuB;;AAEzB;IACI,4BAA4B,EAAE,0BAA0B;AAC5D;AACA;IACI,uBAAuB;IACvB,0BAA0B;IAC1B,uBAAuB;IACvB,kBAAkB;;AAEtB;AACA;IACI,wBAAwB,EAAE,yBAAyB;AACvD;AACA;;;;;;GAMG;AACH;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB,EAAE,kCAAkC;IACpD,mBAAmB,EAAE,oCAAoC;AAC7D;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,eAAe;IACf,qBAAqB;AACzB;;;;;AAKA,gBAAgB;AAChB;IACI,eAAe;IACf,YAAY;AAChB;;AAEA,mBAAmB;AACnB;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA,mCAAmC;AACnC;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,oCAAoC;;AAExC;;AAEA;IACI,4BAA4B;IAC5B,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,mBAAmB;IACnB,wEAAwE;IACxE,mBAAmB;IACnB,cAAc;AAClB;;AAEA,0BAA0B;AAC1B;IACI,kEAAkE;IAClE,uBAAuB;IACvB,4BAA4B;IAC5B,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA,yDAAyD;AACzD;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,6BAA6B;IAC7B,oCAAoC;IACpC,4BAA4B,EAAE,0BAA0B;AAC5D;;AAEA,kBAAkB;AAClB;IACI,KAAK,yCAAyC,EAAE;IAChD,OAAO,2CAA2C,EAAE;AACxD","sourcesContent":[".nav-tabs-wrapper {\n    display: block;\n    overflow: hidden;\n    position: relative;\n    z-index: 1;\n    margin: 40px 0;\n}\n.mb-5, .my-5 {\n    margin-bottom: 3rem !important;\n}\n.filters-box {\n    border-radius: 0.43rem;\n    background-color: #f8f9fa;\n}\n.p-4 {\n    padding: 1.5rem !important;\n}\n.table-responsive.table-borders {\n    border: 0.07rem solid #EBECF0;\n}\n.table-responsive.table-radius {\n    border-radius: 6px;\n}\n.table-responsive {\n    width: 100%;\n}\n.section-services\n{\n    /* padding: 20px; */\n    padding-left: 20px;\n    padding-right: 20px;\n}\na{text-decoration: \"none\"}\n\n.swal2-popup.custom-popup {\n    margin-top: 160px !important; /* Đẩy popup xuống 100px */\n}\n.swal2-input-small {\n    height: 30px !important; \n    font-size: 14px !important;\n    padding: 5px !important; \n    text-align: center; \n    \n}\n.swal2-validation-message::before {\n    display: none !important; /* Ẩn icon lỗi mặc định */\n}\n/* \n.swal2-popup .swal2-loading {\n    position: absolute;\n    top: 80%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n} */\n.form-group {\n    margin-bottom: 15px;\n}\n\n.form-control {\n    font-size: 14px;\n    padding: 5px;\n    width: 100%;\n    min-width: 120px;\n}\n\nselect.form-control {\n    appearance: none; /* Remove default dropdown arrow */\n    padding-right: 30px; /* Space for custom dropdown arrow */\n}\n\n/* Responsive Grid */\n.row.align-items-end {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-end;\n}\n\n\n\n\n/* Date Inputs */\ninput[data-type=\"date\"] {\n    font-size: 14px;\n    padding: 8px;\n}\n\n/* Button Styling */\n.btn-primary {\n    font-size: 13px;\n    padding: 8px 16px;\n}\n\n/* Horizontal Line between inputs */\n.line-f {\n    margin: 0 10px;\n}\n\ninput[type=\"text\"], select {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\nbutton.disabled-button {\n    opacity: 0.5 !important;\n    cursor: not-allowed !important;\n    pointer-events: none; \n}\n\n.header-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    margin-bottom: 20px;\n    position: relative;\n}\n\n.header-line {\n    width: 20%;\n    height: 2px;\n    background-color: rgb(197, 203, 211);\n    \n}\n\n.header-title {\n    background: rgb(24, 98, 200);\n    color: white;\n    font-weight: bold;\n    padding: 10px 40px;\n    text-transform: uppercase;\n    font-size: 16px;\n    letter-spacing: 1px;\n    clip-path: polygon(10% 0%, 90% 0%, 100% 50%, 90% 100%, 10% 100%, 0% 50%);\n    white-space: nowrap;\n    margin: 0 15px; \n}\n\n/* Tùy chỉnh nút Confirm */\n.custom-confirm-button {\n    background: linear-gradient(to right, #007bff, #0056b3) !important;\n    border: none !important;\n    padding: 8px 20px !important;\n    font-size: 16px !important;\n    position: relative;\n}\n\n/* Khi bấm Confirm, spinner xuất hiện và dịch sang trái */\n.swal2-loading .loading-spinner {\n    display: inline-block;\n    width: 18px;\n    height: 18px;\n    border: 3px solid white;\n    border-radius: 50%;\n    border-top-color: transparent;\n    animation: spin 0.8s linear infinite;\n    transform: translateX(-10px); /* Dịch chuyển sang trái */\n}\n\n/* Hiệu ứng xoay */\n@keyframes spin {\n    0% { transform: rotate(0deg) translateX(-10px); }\n    100% { transform: rotate(360deg) translateX(-10px); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
